import { useState } from 'react';

import { settlementBuildingSpriteManifest } from './game/asset-manifest';

/** Reuse the actual world's replaceable building art; names remain real accessible text. */
export function HomeBuildingArtwork({
  code,
  level = 1,
  variant = 'thumbnail',
}: {
  code: string;
  level?: number;
  variant?: 'thumbnail' | 'hero' | 'catalog';
}) {
  const [failedAsset, setFailedAsset] = useState<string>();
  // The catalog calls the garden family garden_plaza; scene snapshots call it garden.
  const sceneType = code === 'garden_plaza' ? 'garden' : code;
  // A new foundation has server level zero; its card previews the first completed home.
  const artworkLevel = level === 0 ? 1 : level;
  const asset = settlementBuildingSpriteManifest.find(
    (entry) =>
      entry.stage === 'completed' &&
      entry.buildingTypes.some((type) => type === sceneType) &&
      (!entry.levels || (artworkLevel >= entry.levels[0] && artworkLevel <= entry.levels[1])),
  );
  if (!asset || failedAsset === asset.id) return null;
  return (
    <span
      aria-hidden="true"
      className={`home-building-artwork home-building-artwork--${variant}`}
      data-building-art={code}
      data-asset-id={asset.id}
    >
      <img
        alt=""
        decoding="async"
        loading={variant === 'thumbnail' ? 'lazy' : 'eager'}
        onError={() => setFailedAsset(asset.id)}
        src={asset.url}
      />
    </span>
  );
}
